module.exports = __webpack_public_path__ + "static/media/skill_sass.c5e5fadb.png";